import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { SubCategoryComponent } from './component/subCategory.component';
import { SubcategoryResolver } from 'src/app/core/services/resolvers/subcategory.resolver';
//import { SubcategoryResolver } from '@app/@core/services/resolvers/subcategory.resolver';

const routes: Routes = [
  {
    path: ':name/:parentName/:previousName',
    component: SubCategoryComponent,
    data: {
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      breadcrumb: (data: any) =>
        `${
          data.faqsSubcategory.breadcrumb
            ? data.faqsSubcategory.breadcrumb
            : '-'
        }`,
    },
    resolve: { faqsSubcategory: SubcategoryResolver },
  },
  {
    path: ':name/:parentName',
    component: SubCategoryComponent,
    data: {
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      breadcrumb: (data: any) =>
        `${
          data.faqsSubcategory.breadcrumb
            ? data.faqsSubcategory.breadcrumb
            : '-'
        }`,
    },
    resolve: { faqsSubcategory: SubcategoryResolver },
  },
  {
    path: ':name',
    component: SubCategoryComponent,
    data: {
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      breadcrumb: (data: any) =>
        `${
          data.faqsSubcategory.breadcrumb
            ? data.faqsSubcategory.breadcrumb
            : '-'
        }`,
    },
    resolve: { faqsSubcategory: SubcategoryResolver },
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SubCategoryRoutingModule {}
